import React, { useState, useEffect } from 'react';
import axios from 'axios';

import 'bootstrap/dist/css/bootstrap.min.css';
import { FaSearch, FaUserPlus, FaEdit, FaTrash } from 'react-icons/fa';
import { Modal, Button, Table, Form, InputGroup, Spinner } from 'react-bootstrap';

const Fournisseur = () => {
  const [fournisseurs, setFournisseurs] = useState([]);
  const [search, setSearch] = useState('');
  const [selectedFournisseur, setSelectedFournisseur] = useState(null);
  const [formData, setFormData] = useState({ nomf: '', numerotele: '' });
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);  // Modal open/close state
  const token = localStorage.getItem('token');

  // Fetch fournisseurs from the server
  useEffect(() => {
    fetchFournisseurs();
  }, []);

  const fetchFournisseurs = async () => {
    try {
      const response = await axios.get('http://localhost:8000/api/fournisseurs', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setFournisseurs(response.data);
    } catch (error) {
      console.error('Erreur lors du chargement des fournisseurs:', error);
    }
  };

  // Handle form submission for adding or editing fournisseur
  const handleSubmit = async () => {
    if (!formData.nomf || !formData.numerotele) {
      alert("Tous les champs sont obligatoires.");
      return;
    }
    setLoading(true);
    try {
      if (selectedFournisseur) {
        // Update fournisseur
        await axios.put(`http://localhost:8000/api/fournisseurs/${selectedFournisseur.id}`, formData, {
          headers: { Authorization: `Bearer ${token}` },
        });
        alert('Fournisseur mis à jour');
      } else {
        // Add new fournisseur
        await axios.post('http://localhost:8000/api/fournisseurs', formData, {
          headers: { Authorization: `Bearer ${token}` },
        });
        alert('Fournisseur ajouté');
      }
      fetchFournisseurs();
      setFormData({ nomf: '', numerotele: '' });
      setSelectedFournisseur(null);
      setShowModal(false);  // Close modal after submit
    } catch (error) {
      console.error('Erreur lors de l\'ajout/mise à jour du fournisseur:', error);
      alert('Une erreur est survenue.');
    } finally {
      setLoading(false);
    }
  };

  // Edit an existing fournisseur
  const handleEditClick = (fournisseur) => {
    setSelectedFournisseur(fournisseur);
    setFormData({
      nomf: fournisseur.nomf,
      numerotele: fournisseur.numerotele,
    });
    setShowModal(true);  // Open modal for editing
  };

  // Delete a fournisseur
  const handleDeleteFournisseur = async (id) => {
    try {
      await axios.delete(`http://localhost:8000/api/fournisseurs/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchFournisseurs();
    } catch (error) {
      console.error('Erreur lors de la suppression du fournisseur:', error);
      alert("Une erreur est survenue lors de la suppression.");
    }
  };

  // Filter fournisseurs based on search input
  const filteredFournisseurs = fournisseurs.filter((fournisseur) =>
    fournisseur.nomf.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="container">
      <h1 className="page-title">Gestion des Fournisseurs</h1>   <br></br>
      <div className="header-section">
        <div className="action-buttons d-flex align-items-center">
          <Button className="btn-custom-primary" onClick={() => setShowModal(true)}>
            <FaUserPlus className="me-2" />
            Ajouter
          </Button>
        </div>
      </div>
   
      <div className="search-section mb-4">
        <InputGroup>
          <InputGroup.Text>
            <FaSearch />
          </InputGroup.Text>
          <Form.Control
            type="text"
            placeholder="Rechercher par nom ou téléphone..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </InputGroup>
      </div>
      <Table bordered>
        <thead>
          <tr>
            <th>Actions</th>
            <th>Nom</th>
            <th>Téléphone</th>
          </tr>
        </thead>
        <tbody>
          {filteredFournisseurs.map((fournisseur) => (
            <tr key={fournisseur.id}>
              <td>
                <Button
                  variant="outline-warning"
                  size="sm"
                  onClick={() => handleEditClick(fournisseur)}
                  className="me-2"
                >
                  <FaEdit />
                </Button>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => handleDeleteFournisseur(fournisseur.id)}
                >
                  <FaTrash />
                </Button>
              </td>
              <td>{fournisseur.nomf}</td>
              <td>{fournisseur.numerotele}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Modal for Add/Edit Fournisseur */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedFournisseur ? 'Modifier Fournisseur' : 'Nouveau Fournisseur'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Nom</Form.Label>
              <Form.Control
                type="text"
                placeholder="Entrez le nom"
                value={formData.nomf}
                onChange={(e) => setFormData({ ...formData, nomf: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Téléphone</Form.Label>
              <Form.Control
                type="text"
                placeholder="Entrez le numéro de téléphone"
                value={formData.numerotele}
                onChange={(e) => setFormData({ ...formData, numerotele: e.target.value })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Annuler
          </Button>
          <Button
            className="btn-custom-primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                {selectedFournisseur ? 'Mise à jour...' : 'Ajout...'}
              </>
            ) : (
              selectedFournisseur ? 'Mettre à jour' : 'Ajouter'
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <style jsx global>{`
        .container {
          padding: 2rem;
          background-color:rgb(255, 255, 255);
     
                 min-height: 80vh;
                    width:50%;
                    margin-right:80%;
        }
      
              .page-title {
                    color: #2c3e50;
                    font-weight: 600;
                    margin: 0;
                }
        .header-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 2rem;
        }
        .btn-custom-primary {
          background-color: #2c3e50;
          border-color: #2c3e50;
          color: white;
        }
        .btn-custom-primary:hover,
        .btn-custom-primary:focus {
          background-color: #1a242f;
          border-color: #1a242f;
        }
          .modal-header {
                    background-color: #2c3e50;
                    color: white;
                    border-radius: 10px 10px 0 0 !important;
                }


                
                .table-header {
                    background-color: #2c3e50;
                    color: white;
                }

                .table-header th {
                    font-weight: 500;
                }

                .modal-content {
                    border-radius: 10px;
                    border: none;
                    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.2);
                }

                .modal-header {
                    background-color: #2c3e50;
                    color: white;
                    border-radius: 10px 10px 0 0 !important;
                }

                .modal-title {
                    font-weight: 500;
                }

                .btn-outline-warning {
                    color: #ffc107;
                    border-color: #ffc107;
                }

                .btn-outline-warning:hover {
                    background-color: #ffc107;
                    color: #212529;
                }

                .btn-outline-danger {
                    color: #dc3545;
                    border-color: #dc3545;
                }

                .btn-outline-danger:hover {
                    background-color: #dc3545;
                    color: white;
                }

                .btn-custom-primary {
                    background-color: #2c3e50;
                    border-color: #2c3e50;
                    color: white;
                    
                }

                .btn-custom-primary:hover,
                .btn-custom-primary:focus {
                    background-color: #1a242f;
                    border-color: #1a242f;
                    color: white;
                }

                @media (max-width: 768px) {
                    .header-section {
                        flex-direction: column;
                        align-items: flex-start;
                    }

                    .action-buttons {
                        width: 100%;
                        flex-direction: column;
                    }

                    .action-buttons .btn {
                        width: 100%;
                        margin-bottom: 0.5rem;
                    }
                }
                      .search-section {
                    max-width: 500px;
                }
      `}</style>
    </div>
  );
};

export default Fournisseur;
